import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useIntegrityInstance} from '../hooks/index';
import {lookupCapa, lookupModality, lookupStatus, Status} from './StageGrid';
import {LookupProps} from 'components/grid-dx/MasterGrid';

const StageGrid = (props: any) => {
  const loadStage = useIntegrityInstance(props.data.key);
  return (
    <IntegrityRoleGrid
      allowEdit={[Roles.AdminITPS, Roles.AdminQA, Roles.AdminHSE]}
      dataSource={loadStage}
      disabledExport={true}
      autoWidth={false}
      id={['iD_Instance', 'iD_Course', 'revision']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
    >
      <Column caption={i18n2._('#Course')} dataField="iD_Course" />
      <Column caption={i18n2._('#Instancia')} dataField="iD_Instance" />
      <Column caption={i18n2._('Nombre del curso')} dataField="course_Name" />
      <Column caption={i18n2._('Modalidad')} dataField="modality">
        <Lookup
          dataSource={lookupModality}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('#Sector')} dataField="sector" visible={false} />
      <Column caption={i18n2._('Nombre del sector')} dataField="sector_Name" />
      <Column
        caption={i18n2._('Fecha de instancia')}
        dataField="instance_Date"
      />
      <Column
        caption={i18n2._('estado')}
        dataField="status"
        width={150}
        cellComponent={(props) => (
          <Status status={props.data.value} text={props.data.text} />
        )}
      >
        <Lookup
          dataSource={lookupStatus}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('Observacion')} dataField="observations" />
      <Column caption={i18n2._('Capa inicial')} dataField="capaIniLeg">
        <Lookup
          dataSource={lookupCapa}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column
        caption={i18n2._('Duracion')}
        visible={false}
        dataField="duration"
      />
      <Column caption={i18n2._('Instructor')} dataField="instructor" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        visible={false}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        visible={false}
        dataField="updatedBy"
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default StageGrid;
